// 定价方式字典（与后端 enum 一致）
export const adjustTypeDic = [
  { label: "固定价", value: "FIXED" },
  { label: "折扣率", value: "DISCOUNT" },
  { label: "加减金额", value: "ADD" },
  { label: "公式价", value: "FORMULA" },
];

// 审批状态中文文案（map 取值）
export const approvalStatusTextMap = {
  PENDING: "审批中",
  APPROVED: "已通过",
  REJECTED: "已驳回",
  CANCELLED: "已撤销",
};

// 展示状态标签颜色
export const displayStatusTagType = {
  审批中: "warning",
  已驳回: "danger",
  已撤销: "info",
  生效失败: "danger",
  未开始: "info",
  生效中: "success",
  已过期: "warning",
  已作废: "info",
};

// 调价任务列表表格配置（批次维度，taskList）
export const priceAdjustTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  stripe: true,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: false,
  menu: true,
  menuWidth: 150,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  columnBtn: false,
  menuType: "text",
  column: [
    {
      label: "任务标题",
      prop: "title",
      minWidth: 220,
      showOverflowTooltip: true,
    },
    {
      label: "定价方式",
      prop: "adjustTypeName",
      width: 100,
      solt: true,
    },
    {
      label: "调价参数",
      prop: "adjustValue",
      minWidth: 200,
      showOverflowTooltip: true,
      solt: true,
    },
    {
      label: "生效时间",
      prop: "effectiveStartTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
    {
      label: "失效时间",
      prop: "effectiveEndTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
    {
      label: "明细条数",
      prop: "itemCount",
      width: 90,
    },
    /* {
      label: "审批状态",
      prop: "approvalStatus",
      width: 100,
      slot: true,
    }, */
    {
      label: "审批状态",
      prop: "displayStatus",
      width: 100,
      slot: true,
    },
    {
      label: "发起人",
      prop: "applicantName",
      width: 100,
    },
    {
      label: "提交时间",
      prop: "submitTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
    {
      label: "完成时间",
      prop: "finishTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
  ],
};
